import { createStore } from "vuex";

const store = createStore({
  state: {
    verdorId: "",
  },
  mutations: {},
  actions: {},
});

export default store;
